'use client';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.15);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledLoadingModal = styled.div`
  display: flex;
  height: 280px;
  width: 530px;
  padding: ${({ theme }) => theme.spacing(8)};
  border-radius: ${({ theme }) => theme.spacing(8)};
  background-color: ${({ theme }) => theme.colors.neutral.lightBone};
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
  @media (max-width: 768px) {
    height: 160px;
    max-width: 260px;
  }
`;

export const StyledLoadingSpinner = styled.div`
  border: 4px solid #00000063;
  border-top: 4px solid #000;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  padding: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    height: 15px;
    width: 15px;
  }
`;

export const StyledDescriptionText = styled.p`
  font-size: 30px;
  text-align: center;
  padding: ${({ theme }) => theme.spacing(2)};
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const StyledProgressBar = styled.div`
  width: 100%;
  height: 20px;
  background-color: rgba(166, 153, 145, 0.25);
  margin-top: ${({ theme }) => theme.spacing(6)};
  border-radius: ${({ theme }) => theme.spacing(8)};
  flex-direction: row;
  align-self: flex-start;
  @media (max-width: 768px) {
    height: 10px;
    margin-top: ${({ theme }) => theme.spacing(4)};
  }
`;

export const StyledProgress = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.darkerFur};
  border-radius: ${({ theme }) => theme.spacing(8)};
  height: 20px;
  width: ${props => props.$width};
  @media (max-width: 768px) {
    height: 10px;
  }
`;
